import { range } from "ramda";

import { useScreen } from "hooks";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

import { Description, StyledFitText, StyledPlaceholder } from "./styles";

const TemplateGroupDescription = ({ templateGroup }) => {
  const { isMobile } = useScreen();

  const description = TemplateGroupPresenter.description(templateGroup);

  const renderPlaceholder = () => {
    return range(0, 3).map((index) => <StyledPlaceholder key={`template-group-description-${index}`} variant="text" />);
  };

  const renderDescription = () => {
    return (
      <Description component="p">
        {isMobile ? (
          <StyledFitText max={16} min={15}>
            {description}
          </StyledFitText>
        ) : (
          <>{description}</>
        )}
      </Description>
    );
  };

  return templateGroup ? renderDescription() : renderPlaceholder();
};

TemplateGroupDescription.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
};

export default TemplateGroupDescription;
